import React from "react";

import styled from "styled-components";

import clipboard from "../assets/svg/clipboard.svg";
import clockArrow from "../assets/svg/clockArrow.svg";
import flag from "../assets/svg/flag.svg";
import newFile from "../assets/svg/newFile.svg";
import pencilRuler from "../assets/svg/pencilRuler.svg";
import speechBubbles from "../assets/svg/speechBubbles.svg";
import thumbsUp from "../assets/svg/thumbsUp.svg";
import trophy from "../assets/svg/trophy.svg";
import user from "../assets/svg/user2.svg";

import { ReactComponent as CloseIcon } from "../assets/svg/closeIcon.svg";

export const ActionPlan: React.FC<{}> = () => {
  const [selected, setSelected] = React.useState<number>(-1);

  const handleSelection = (id: number): void => {
    selected === id ? setSelected(-1) : setSelected(id);
  };

  return (
    <div className="d-flex flex-wrap justify-content-center mb-4">
      {data.map(({ imgSrc, title }, idx) => (
        <ButtonWrapper key={idx}>
          <StyledButton onClick={() => handleSelection(idx)}>
            <img src={imgSrc} alt="" />
          </StyledButton>
          <StyledTitle>{title}</StyledTitle>
        </ButtonWrapper>
      ))}
      <Information active={selected !== -1}>
        {selected !== -1 && (
          <>
            <strong className="text-gold mb-3">{data[selected].title}</strong>
            <p className="text-white mb-2">{data[selected].description}</p>
            <button
              onClick={() => handleSelection(selected)}
              css={`
                background-color: transparent;
                border: 0;
              `}
            >
              <CloseIcon width={20} height={20} fill="white" />
            </button>
          </>
        )}
      </Information>
    </div>
  );
};

const Information = styled.div<{ active: boolean }>`
  position: absolute;
  transition: all 500ms cubic-bezier(0.34, 1.56, 0.64, 1);
  top: ${(p) => (p.active ? "calc(50% - 12.5rem)" : "50%")};
  left: ${(p) => (p.active ? "calc(50% - 12.5rem)" : "50%")};
  width: ${(p) => (p.active ? "25rem" : "0")};
  height: ${(p) => (p.active ? "25rem" : "0")};
  opacity: ${(p) => (p.active ? 1 : 0)};
  background: ${(p) => p.theme.info};
  border-radius: 50%;
  padding: 2rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  position: relative;
  width: 10rem;
  height: 10rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
`;

const StyledButton = styled.button`
  position: absolute;
  top: 0;
  left: 12.5%;
  width: 75%;
  height: 75%;
  padding: 1rem;
  background: ${(p) => p.theme.primary};
  border: none;
  border-radius: 50%;
  &:focus {
    outline: none;
  }
`;

const StyledTitle = styled.strong`
  position: absolute;
  left: 12.5%;
  bottom: 0;
  height: 20%;
  width: 75%;
  text-align: center;
`;

interface Data {
  imgSrc: any;
  title: string;
  description: string;
}

const data: Data[] = [
  {
    imgSrc: trophy,
    title: "A goal",
    description:
      "A goal describes the overall aim of your health and wellbeing program. Goals need to consider the big picture (3 to 5 years). Changing behaviour can take a long time, so your goal needs to reflect this e.g. to improve the health and wellbeing of the workforce.",
  },
  {
    imgSrc: flag,
    title: "Objectives",
    description:
      "Objectives state how you will achieve your goal. These are shorter term (6 – 12 months) and are more specific. You may have a couple or several, depending on how many health risk behaviours you’re targeting e.g. increase by 20% the proportion of factory workers achieving 30 minutes of physical activity everyday over the next 12 months.",
  },
  {
    imgSrc: newFile,
    title: "Strategies",
    description:
      "Strategies include the steps you’ll take to implement your objective. Ensure you consider policy, environment, education and activities e.g. create a lunchtime walking group, equip staff kitchen with adequate food preparation equipment.",
  },
  {
    imgSrc: clipboard,
    title: "Tasks",
    description:
      "Tasks include the day-to-day activities that need to be carried out to achieve your strategies. This step helps you to break down the specific tasks that need to be done, and to plan your timeframe e.g. form a working group to develop / review policy, obtain a quote from three health professionals.",
  },
  {
    imgSrc: pencilRuler,
    title: "Resources and tools",
    description:
      "What will be needed to implement your strategies? Include materials, money and time e.g. Workplace Health Coordinator’s time, promotional materials, health professionals.",
  },
  {
    imgSrc: user,
    title: "Key people",
    description:
      "Include people who will coordinate or be involved in running the strategy e.g. Workplace Health Coordinator and working group members.",
  },
  {
    imgSrc: clockArrow,
    title: "Timeframe",
    description:
      "When strategies will run, how long they will run for, and expected completion date e.g. 3 months (Jan – Mar 20xx).",
  },
  {
    imgSrc: thumbsUp,
    title: "Measure of success",
    description:
      "What criteria you will use to evaluate if your strategies were successful and your objectives were met e.g. the proportion of staff who know about the the new health and wellbeing policy, changes in the amount that gym equipment is use, changes in the proportion of staff who smoke.",
  },
  {
    imgSrc: speechBubbles,
    title: "Evaluation method/s",
    description:
      "How will you evaluate whether you have met your success criteria? e.g. staff awareness survey.",
  },
];
